// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22h2c","title":"Header_title__piOr4","left":"Header_left__2e1u5","clinicName":"Header_clinicName__3rqVl"};